.ck{display:inline-flex;}